var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwistLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 539.3 247.5",
    style: {
      enableBackground: "new 0 0 539.3 247.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF9933;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.5,35.7v19h-16v19.7c0,6.9,0,11.5,8.4,11.5h7.7v19.3h-12.5c-17.3,0-25.5-11.6-25.5-24.7V19.2h22v16.5 H256.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.1,36.2h22.7v40.9c0,4.3,1.8,7.9,7.2,7.9s7.2-3.7,7.2-7.9V36.2h22.7v40.9c0,4.3,1.8,7.9,7.2,7.9 c5.4,0,7.2-3.7,7.2-7.9V36.2h22.7v44.5c0,16-13.8,26.1-28.9,26.1c-7.2,0-14.6-4-19.6-9.6c-5,5.7-12.3,9.6-19.6,9.6 c-15.2,0-28.9-10.1-28.9-26.1V36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.1,105.2h-22.7V36.2h22.7V105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.5,85.9h21.8c2.7,0,4-1.3,4-3.1c0-6.5-25.1-4.1-25.1-27c0-13,11.3-19.6,22.1-19.6h22.1v18.4h-17.7 c-2.7,0-4.7,1.4-4.7,3.3c0,5.5,26.5,6.9,26.5,25.5c0,14-8.8,21.7-23.7,21.7h-25.4V85.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.1,35.7v20.7h-16.2v18.4c0,7.9,2.8,9.4,11.6,9.6c1.6,0,3.3-0.1,4.8-0.3v21h-12.8 c-17.3,0-25.5-11.6-25.5-24.7V19.2h22v16.5H504.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.1,164.2c0-20.7-15.9-36.3-37.9-36.3c-20.1,0-39.1,11.3-39.1,33.5v67h22.7v-61.4 c0-10.6,5.2-18.3,16-18.3c8.8,0,15.6,6.4,15.6,15.5s-6.8,15.5-15.6,15.5c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0 c-5.7,0-10.3,4.6-10.3,10.3c0,5.5,4.3,9.9,9.6,10.3l0,0c0,0,2.7,0.1,4.3,0c0,0,0,0,0,0C297.7,199.3,315.1,187,315.1,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344,141.1h0.3c3.4-9.8,9.9-11.5,19.9-11.5v20.7c-15.7,0.6-17.2,4-17.2,15.9v32.3h-22.7v-68.9H344V141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.3,198.5h-22.7v-68.9h22.7V198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.5,198.5v-39.4c0-17.9,10.4-31.2,29.6-31.2c19.3,0,29.6,13.3,29.6,31.2v39.4H449v-39.4 c0-6-3-9.7-7.8-9.7c-4.8,0-7.8,3.7-7.8,9.7v39.4H411.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.1,129v20.7h-16.2v18.4c0,7.9,2.8,9.4,11.6,9.6c1.6,0,3.3-0.1,4.8-0.3v21h-12.8 c-17.3,0-25.5-11.6-25.5-24.7v-61.3h22V129H520.1z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.9,155.1L217.9,155.1c0-1.7-1.4-3.1-3.1-3.1v0H193V90.9c0,0,0,0,0,0c0-0.2,0-0.4-0.1-0.5c0-0.1,0-0.1,0-0.2 c0-0.1-0.1-0.2-0.1-0.4c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0,0-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3 c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.3-0.2-0.5-0.2c0,0-0.1,0-0.1,0 c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.6-0.1h-33.2V27.3c0-1.7-1.4-3.1-3.1-3.1H22.3c-1.7,0-3.1,1.4-3.1,3.1 v108.4c0,1.7,1.4,3.1,3.1,3.1h49.6v46.9c0,1.7,1.4,3.1,3.1,3.1h57.8v31.4c0,1.7,1.4,3.1,3.1,3.1h78.8c1.7,0,3.1-1.4,3.1-3.1 L217.9,155.1L217.9,155.1z M193,158.2h15.2L193,176.9V158.2z M156.7,94h26.6l-26.6,32.9V94z M25.4,132.6V30.4h125v102.1H25.4z  M78.1,182.6v-43.8h71.1h4.2c1,0,2-0.5,2.6-1.3l30.6-37.8v82.9H78.1z M211.7,217h-72.6v-28.2h50.8c1.1,0,2.1-0.6,2.6-1.4l19.1-23.5 V217z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwistLogo);
export default __webpack_public_path__ + "static/media/twist-logo.bce3844f5d64770a1f7361d87d058bd5.svg";
export { ForwardRef as ReactComponent };